import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official'; // Or use @highcharts/react components
import 'highcharts/modules/exporting';
import { Typography } from '@mui/material';

interface ChartProps {
  title: string;
  id: number;
  height: number;
}

const BarChart: React.FC<ChartProps> = ({ title, id, height = 345 }) => {
  const [categories, setCategories] = React.useState([]);
  const [currentSales, setCurrentSales] = React.useState([]);
  const [modelSales, setModelSales] = React.useState([]);
  
  const chartComponentRef = React.useRef<HighchartsReact.RefObject>(null);
  React.useEffect(() => {
    fetch(`/dashboard/current-vs-opportunity-sales/${id}/?entity_id=${localStorage.getItem('entity_id')}`)
      .then(response => response.json())
      .then(data => 
        setTimeout(() => {
          setCategories(data.categories);
          setCurrentSales(data.current_sales);
          setModelSales(data.model_sales);
        }, 100)
      );

    const handleResize = () => {
      if (chartComponentRef.current && chartComponentRef.current.chart) {
        chartComponentRef.current.chart.reflow();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const options: Highcharts.Options = {
        chart: {
            type: 'column',
            zooming: {
                type: 'xy' as const
            }
        },
        title: {
            text: title,
            align: 'left'
        },
        
        xAxis: {
            crosshair: true,
            accessibility: {
                description: ''
            },
            title: {
                text: 'Products',
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            },
            // minRange: 10,
            categories: categories
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Sales ($)',
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            },
            labels: {
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            }
        },
        tooltip: {
            valueSuffix: ' ($)'
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        series: [
            {
                type: 'column',
                name: 'Last 2 Years Sales',
                data: currentSales
            },
            {
                type: 'column',
                name: 'Potential Additional Opportunity',
                data: modelSales
            }
        ]
    };

    return (
        <div style={{ height: '100%', width: '100%' }}>
          {currentSales.length > 0 && modelSales.length > 0 ? (
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
                allowChartUpdate={true}
                exportEnabled={true}
                ref={chartComponentRef}
                containerProps={{ style: { width: '100%', height: height, borderRadius: 5, boxShadow: 'none', margin: 0, padding: 0 } }}
            />
          ) : (
            <Typography variant="body1" sx={{ color: 'text.secondary', textAlign: 'center' }}>No data available</Typography>
          )}
        </div>
    );
};

export default BarChart;
